import { Building2 } from 'lucide-react';

export function Header() {
  return (
    <header className="fixed top-0 left-0 right-0 bg-white/95 backdrop-blur-sm shadow-sm z-50">
      <div className="max-w-6xl mx-auto px-6 py-4 flex items-center justify-between">
        <div className="flex items-center gap-3">
          <Building2 className="w-8 h-8 text-neutral-900" strokeWidth={1.5} />
          <div>
            <h1 className="text-xl font-normal text-neutral-900">AK-KUR Furniture & Fitting Ltd</h1>
            <p className="text-xs text-neutral-600">kurfurniture.co.uk</p>
          </div>
        </div>
      </div>
    </header>
  );
}
